import React, { useState} from "react";
import { useForm } from "react-hook-form";
import { useSelector, useDispatch } from "react-redux";
import { ChangePassword } from '../../services/api/loginService';
import AlertService from "../../services/utility/alertService";
import ErrorMessage from '../../pages/shared/ErrorMessage';
import { alertMessages, apiStatus } from "../../constants/app-constant";


function AppChangePassword() {
    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const isLoading = false;
    const [invalidPassword, setInvalidPassword] = useState(false);

    const { register, handleSubmit, formState: { errors }, getValues, reset } = useForm({
        mode: "all",
    });

    const onSubmit = async(formvalues) => {
        try {
            isLoading = true;
            console.log(formvalues);
            
            const response = await ChangePassword(formvalues);
            if (response.status != 200) {
                setInvalidPassword(true);
            } else {
                AlertService.successAlert(alertMessages.passwordChangeSuccess).then((response) => {
                    // if (response.isConfirmed) {
                    //  dispatch(resetPasswordChangeStatus());
                    reset();
                    //}
                });
            }
           
            isLoading = false;
        } catch (err) {
            isLoading = false;
        }
    };

    const onError = (formvalues) => {
        console.log(formvalues)
    };

    const IsPasswordConfirmationMatching = (value) => {
        const { newPassword } = getValues();
        return newPassword === value;
    }

    const IsSameAsExisting = (value) => {
        const { oldPassword } = getValues();
        return oldPassword !== value;
    }

    //if (passwordChangeStatus == apiStatus.successCode) {
    //    AlertService.successAlert(alertMessages.passwordChangeSuccess).then((response) => {
    //        if (response.isConfirmed) {
    //            dispatch(resetPasswordChangeStatus());
    //            reset();
    //        }
    //    });
    //}

    const valueChanged = () => {

    }


    return (
        <><div className="card aon-card login_section">
            <div className="card-header aon-card-header">
                <h4><i className="fa fa-user"></i> Change Password</h4>
            </div>
            <div className="card-body aon-card-body">
                <div className="sf-tabs-content">
                    <form className="aon-login-form" onSubmit={handleSubmit(onSubmit, onError)}>
                        <div className="row">

                            <div className="col-md-12">
                                <div className={`form-group ${errors.oldPassword ? 'error_field' : ''}`}>
                                    <div className="aon-inputicon-box">
                                        <input className="form-control sf-form-control"
                                            name="oldPassword" type="text" id="oldPassword" placeholder="Old Password"
                                            {...register("oldPassword", {
                                                required: true,
                                                onChange: valueChanged
                                            })}
                                        />
                                        <i className="aon-input-icon fa fa-lock"></i>
                                    </div>
                                    {
                                        errors.oldPassword &&
                                        <ErrorMessage errorType={errors.oldPassword.type} errorFieldName={'Old Password'} />
                                    }
                                </div>
                            </div>

                            <div className="col-md-12">
                                <div className={`form-group ${errors.newPassword ? 'error_field' : ''}`}>
                                    <div className="aon-inputicon-box">
                                        <input className="form-control sf-form-control"
                                            name="newPassword" type="text" id="newPassword" placeholder="New Password"
                                            {...register("newPassword", {
                                                required: true,
                                                maxLength: 20,
                                                minLength: 8,
                                                pattern: /^(?=.*[A-Z])(?=.*[\W_]).{8,}$/,
                                                onChange: valueChanged,
                                                validate: {
                                                    IsPasswordSameaAsOld: (newPassword) => IsSameAsExisting(newPassword),
                                                }
                                            })}
                                        />
                                        <i className="aon-input-icon fa fa-lock"></i>
                                    </div>
                                    {
                                        errors.newPassword &&
                                        <ErrorMessage errorType={errors.newPassword.type} errorFieldName={'New Password'} maxLength={'20'} minLength={'8'} />
                                    }
                                </div>
                            </div>

                            <div className="col-md-12">
                                <div className={`form-group ${errors.confirmPassword ? 'error_field' : ''}`}>
                                    <div className="aon-inputicon-box">
                                        <input className="form-control sf-form-control"
                                            name="confirmPassword" type="password" placeholder="Confirm Password"
                                            {...register("confirmPassword", {
                                                required: true,
                                                maxLength: 20,
                                                minLength: 8,
                                                onChange: valueChanged,
                                                validate: {
                                                    IsPasswordConfirmationMatching: (confirmPassword) => IsPasswordConfirmationMatching(confirmPassword),
                                                }
                                            })}
                                        />
                                        <i className="aon-input-icon fa fa-lock"></i>
                                    </div>
                                    {
                                        errors.confirmPassword &&
                                        <ErrorMessage errorType={errors.confirmPassword.type} errorFieldName={'Confirm password'} maxLength={'20'} minLength={'8'} />
                                    }
                                </div>
                            </div>

                            {
                                invalidPassword && (
                                    <div className="col-md-12" >
                                        <div className="bg-danger text-danger p-2 mb-4 rounded">
                                            {alertMessages.passwordChangeFailures}
                                        </div>
                                    </div>
                                )
                            }
                            <div className="col-md-12">
                                <button type="submit" className="site-button w-100">{isLoading ? '' : 'Update Password'}
                                    <i className={isLoading ? 'fa fa-spinner fa-spin fa-2x text-white' : 'feather-arrow-right'}></i></button>
                            </div>

                        </div>
                    </form>
                </div>
            </div>
        </div>
        </>
    )
}

export default AppChangePassword;